var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":_vm.title,"value":_vm.value,"footer-hide":"","fullscreen":""},on:{"on-visible-change":_vm.visibleChange}},[_c('sqlForFrom',{attrs:{"patient":_vm.patient,"configureProject":'医生随访表单'}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cbc0a40","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/follow/followForm/followDoctorForSql.vue
// module id = null
// module chunks = 